export interface EncerramentoParcialValido {
  readonly saldoNaoProduzido: number;
  readonly justificativa: string;
}

/** Validação e corpo único do POST; o servidor continua sendo a autoridade final. */
export function validarEncerramentoParcial(saldo: string, justificativa: string, pendente: number): EncerramentoParcialValido | string {
  const saldoNaoProduzido = Number(saldo);
  if (!Number.isFinite(saldoNaoProduzido) || saldoNaoProduzido <= 0 || saldoNaoProduzido > pendente) {
    return `Informe um saldo maior que zero e até ${pendente}.`;
  }
  const justificativaNormalizada = justificativa.trim();
  if (justificativaNormalizada.length < 5) return 'A justificativa deve ter ao menos 5 caracteres.';
  return { saldoNaoProduzido, justificativa: justificativaNormalizada };
}

/** Permissões de Produção são deliberadamente distintas da gestão do quadro Kanban. */
export function podeEncerrarOpParcial(opStatus: string | undefined, podeGerenciarProducao: boolean): boolean {
  return podeGerenciarProducao && (opStatus === 'LIBERADA' || opStatus === 'EM_PRODUCAO');
}

/** O CP exige ambos os identificadores para nunca abrir uma OP de outro lote. */
export function rotaCartaoControle(loteId: string | null | undefined, opId: string | null | undefined, podeConsultarProducao: boolean): string | null {
  if (!podeConsultarProducao || !loteId || !opId) return null;
  return `/producao/cartao-controle?loteId=${encodeURIComponent(loteId)}&opId=${encodeURIComponent(opId)}`;
}
